import logger from './logger.ts';

let flagsCssLoadPromise: Promise<unknown> | null = null;

export const ensureFlagsCssLoaded = () => {
  if (!flagsCssLoadPromise) {
    flagsCssLoadPromise = import('../flags.css').catch((error) => {
      logger.error('Failed to load flags.css: ' + (error instanceof Error ? error.message : String(error)));
      flagsCssLoadPromise = null;
      throw error;
    });
  }

  return flagsCssLoadPromise;
};
